import type { Directive, DirectiveBinding } from 'vue'

type CopyBinding = DirectiveBinding<string | undefined>

const handlers = new WeakMap<HTMLElement, () => void>()

const setCopyFeedback = (el: HTMLElement): void => {
  const originalBackground = el.style.backgroundColor
  el.style.backgroundColor = '#4CAF50'

  window.setTimeout(() => {
    el.style.backgroundColor = originalBackground
  }, 200)
}

const createHandler = (el: HTMLElement, binding: CopyBinding) => {
  return async () => {
    try {
      const textToCopy = binding.value ?? el.innerText
      await navigator.clipboard.writeText(textToCopy)
      setCopyFeedback(el)
    } catch (error) {
      console.error('Failed to copy text:', error)
    }
  }
}

export const vCopy: Directive<HTMLElement, string | undefined> = {
  mounted(el: HTMLElement, binding: CopyBinding) {
    el.style.cursor = 'pointer'

    const handler = createHandler(el, binding)
    handlers.set(el, handler)
    el.addEventListener('click', handler)
  },

  beforeUnmount(el: HTMLElement) {
    const handler = handlers.get(el)

    if (!handler) {
      return
    }

    el.removeEventListener('click', handler)
    handlers.delete(el)
  }
}